import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted,ref } from "vue";


/**
 * 菜单转跳 本项目页面地址
 * */

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const VUE_APP_NAME = process.env.VUE_APP_NAME;
const NODE_ENV = process.env.NODE_ENV;
console.log('VUE_APP_NAME',VUE_APP_NAME,NODE_ENV)
const routerName = ref('index')
const defaultRouter = ref(true)


onMounted(async () => {
  if(routerName.value === 'DEVOPS'){
    defaultRouter.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})